/* @flow */

import * as React from 'react';
import { Skeleton } from '@mui/material';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './NotificationCard.style';

const useStyles = createUseThemeStyles(styles);

const NotificationCardSkeleton = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.top}></div>
      <div className={classes.body}>
        <Skeleton variant="circular" width={50} height={50} />
        <span className={classes.text}>
          <Skeleton variant="text" height={20} />
        </span>
      </div>
    </div>
  );
};

export default React.memo<{}>(NotificationCardSkeleton);
